<template>
  <div class="occupancy-chart">
    <h3 class="occupancy-chart__title">Ocupación histórica</h3>
    <div class="occupancy-chart__canvas-wrap">
      <canvas ref="canvasRef"></canvas>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'
import Chart from 'chart.js/auto'

const props = defineProps({
  history: { type: Array, default: () => [] },
})

const canvasRef = ref(null)
let chartInstance = null

const MONTHS_SHORT = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']

function buildChart() {
  if (!canvasRef.value) return

  chartInstance = new Chart(canvasRef.value, {
    type: 'line',
    data: {
      labels: props.history.map((h) => MONTHS_SHORT[h.month - 1]),
      datasets: [
        {
          label: 'Ocupación %',
          data: props.history.map((h) => h.occupancyPercent),
          borderColor: 'rgb(61, 155, 255)',
          backgroundColor: 'rgba(61, 155, 255, 0.15)',
          fill: true,
          tension: 0.3,
          pointRadius: 3,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: { legend: { display: false } },
      scales: {
        y: {
          min: 0,
          max: 100,
          ticks: { color: '#6e8ab0', callback: (v) => `${v}%` },
          grid: { color: 'rgba(255,255,255,0.05)' },
        },
        x: {
          ticks: { color: '#6e8ab0' },
          grid: { display: false },
        },
      },
    },
  })
}

onMounted(async () => {
  await nextTick()
  buildChart()
})

watch(
  () => props.history,
  async () => {
    if (chartInstance) chartInstance.destroy()
    await nextTick()
    buildChart()
  }
)

onBeforeUnmount(() => {
  if (chartInstance) chartInstance.destroy()
})
</script>

<style scoped>
.occupancy-chart {
  background: var(--bg-surface-1);
  border: 1px solid var(--border-active);
  border-radius: 10px;
  padding: 1rem 1.1rem;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.occupancy-chart__title {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-content);
  font-family: var(--font-body);
  margin-bottom: 0.75rem;
}

.occupancy-chart__canvas-wrap {
  flex: 1;
  min-height: 0;
  position: relative;
}
</style>